import { map } from 'ramda'
import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import CheckboxesFilterSideModal from '../../../components/filter/CheckboxesFilterSideModal'
import ServiceOrdersLoader, { useServiceOrders } from './_load/ServiceOrdersLoader'

const ServiceOrdersFilterSideModal = ({ field, label, onClose, ...props }) => {
  const { t } = useTranslation('serviceOrders')
  field = field || 'serviceOrderIds'
  label = label || t('defaultLabel')
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <CheckboxesFilterSideModal
      label={label}
      value={value}
      dataHook={useServiceOrders}
      onClose={v => {
        handleChange(field, v)
        onClose()
      }}
      Loader={ServiceOrdersLoader}
      useSearch
      mapOptions={map(item => ({ label: item.yearlyId, value: item.id, origin: item }))}
      {...props}
    />
  )
}

export default ServiceOrdersFilterSideModal
